import { render } from "./TimeFrameDisplay.vue?vue&type=template&id=f76bba04"
import script from "./TimeFrameDisplay.vue?vue&type=script&lang=js"
export * from "./TimeFrameDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__